export const GET_SUBS_DATA = 'subs/GET_SUBS_DATA';
export const GET_SUBS_DATA_SUCCESS = 'subs/GET_SUBS_DATA_SUCCESS';
export const GET_SUBS_DATA_FAIL = 'subs/GET_SUBS_DATA_FAIL';
export const GET_ACTIVE_SUB_DATA = 'subs/GET_ACTIVE_SUB_DATA';
export const GET_ACTIVE_SUB_DATA_SUCCESS = 'subs/GET_ACTIVE_SUB_DATA_SUCCESS';
export const GET_ACTIVE_SUB_DATA_FAIL = 'subs/GET_ACTIVE_SUB_DATA_FAIL';
export const GET_SUBS_DRILL_DATA = 'subs/GET_SUBS_DRILL_DATA';
export const GET_SUBS_DRILL_DATA_SUCCESS = 'subs/GET_SUBS_DRILL_DATA_SUCCESS';
export const GET_SUBS_DRILL_DATA_FAIL = 'subs/GET_SUBS_DATA_FAIL';
export const GET_LOOKUP_DATA = 'subs/GET_LOOKUP_DATA';
export const GET_LOOKUP_DATA_SUCCESS = 'subs/GET_LOOKUP_DATA_SUCCESS';
export const GET_LOOKUP_DATA_FAIL = 'subs/GET_LOOKUP_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/subs.js